import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../locales/useTranslations';

const WebentwicklungIhrPartnerinderEntwicklung = () => {
    const { t } = useTranslations();

    return (
        <section className="about-area ptb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <span className="sub-title">{t('digitalTransformation')}</span>
                            <h2>{t('webDevelopment_partner_title')}</h2>
                            <p>{t('webDevelopment_partner_description')}</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-image webdev-partner__image-wrapper">
                            {/* Dekorative Hintergrund-Elemente */}
                            <div className="webdev-partner__decoration webdev-partner__decoration--top"></div>
                            <div className="webdev-partner__decoration webdev-partner__decoration--bottom"></div>

                            {/* Hauptbild-Container */}
                            <div className="webdev-partner__image-card">
                                <Image
                                    src="/images/web-development/webdev.webp"
                                    alt="simplify data - web development"
                                    width={0}
                                    height={0}
                                    sizes="100vw"
                                    className="webdev-partner__main-image"
                                />
                            </div>

                            {/* Floating Elements */}
                            <div className="webdev-partner__floating-tag webdev-partner__floating-tag--primary">
                                Web Development
                            </div>

                            <div className="webdev-partner__floating-tag webdev-partner__floating-tag--secondary">
                                Modern Design
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WebentwicklungIhrPartnerinderEntwicklung;
